import styled from 'styled-components'

const Wrapper = styled.div`
  height: ${props => props.height}px;
`

/** @component */
export default Wrapper
